import { render, staticRenderFns } from "./IdentityInput.vue?vue&type=template&id=f7c54caa&"
import script from "./IdentityInput.vue?vue&type=script&lang=js&"
export * from "./IdentityInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports